<template>
    <div id="chuangHeader">
        <div class="row">
            <div class="col s12 m12 l11 xl11">
                <div class="clearfix col-left">
                    <a href="#chuangIntroduction">
                        <img class="left chuang-logo"  src="../assets/images/logo-pc.png" alt="">
                    </a>
                    <ul  :class="{'valign-wrapper right chuang-links hide-on-med-and-down': true , 
                                    'list-adjust-margin': selectedLanguange !== 2,
                                    'chuang-links-for-c-char': selectedLanguange !== 2}">
                        <a @click="showLanguange = false, startPageAnimation(i) " :href="v.link" v-for="(v, i) in headerLanguages">
                            <li @click="changeActiveLink(i), popModalShow(false)" :class="{'left valign-wrapper': true, 'active-link': isActiveLink(i) }">
                                <p v-html="v.title[selectedLanguange]"></p>
                            </li>
                        </a>
                    </ul>

                    <img v-if="showList" @click="show(false), popModalShow(false)" class="close right hide-on-large-only" src="../assets/images/close.png" alt="">
                    <img v-if="!showList" @click="show(true), popModalShow(true)" class="hamburger right hide-on-large-only" src="../assets/images/hamburger.png" alt="">
                </div>
            </div>
            <div @click="showLanguange = !showLanguange, popModalShow(showLanguange)" :class="{'col l1 xl1 hide-on-med-and-down col-right valign-wrapper': true}">
                <p  :class="{'list-text-size-for-c-char': selectedLanguange !== 2, 
                            'arrow-down-eng': selectedLanguange == 2}" 
                            v-html="" >
                            {{ languages[selectedLanguange] }} 
                            <span :class="{'arrow-down': true}"></span>
                </p>
            </div>
        </div>
        <div v-if="showList" class="mobile-list hide-on-large-only">
            <div class="row mobile-language-select">
                <a href="#chuangIntroduction">
                <div v-for="(v, i) in languages" @click="changeLanguage(i), popModalShow(false)" :class="{'col s4': true, 'c-char-space': isChineseChar(i), 'active': isSelected(i) }">
                    {{v}}
                </div>
                </a>
            </div>

            <ul class="link">
                <a @click="show(false), popModalShow(false)" v-for="headerLink in headerLanguages" :key="headerLink.id" :href="headerLink.link">
                    <li class="mobile-links-text clearfix" >
                        <img :src="headerLink.icon" class="left" alt="">
                        <p class="left">{{ headerLink.char }}</p> 
                        <p :class="{'left':true, 'mobile-text-english': selectedLanguange == 2}">{{ headerLink.title[selectedLanguange] }}</p>
                    </li>
                </a>
            </ul>
        </div>
        <div v-if="showLanguange" :class="{'selectLanguage hide-on-med-and-down': true,
                                                                'animated fadeIn': showLanguange == true,
                                                                    'animated fadeOutRight': showLanguange == false}">
            <ul>
                <li @click="changeLanguage(v), popModalShow(false)" v-for="(k, v) in languages" v-html="k"></li>
            </ul>
        </div>
    </div> 
</template>

<script>
    const b = 1;
    export default {
        data() {
            return {
                compHeight: 0,
                coreHeight: 0,
                introHeight: 0,
                magHeight: 0,
                perHeight: 0,
                languages: ['繁體中文', '简体中文', 'ENGLISH'],
                headerLanguages: [
                    {
                        title: ['首頁', '首页' , 'HOME'],
                        link: '#chuangIntroduction',
                        icon: require('../assets/images/home-link-icon.png')
                    },                       

                    {
                        title: ['經營理念', '经营理念' , 'MANAGEMENT PHILOSOPHY'],
                        link: '#manageLink',
                        icon: require('../assets/images/management-link-icon.png')
                    },
                    {
                        title: ['競爭優勢', '竞争优势' , 'COMPETITIVE ADVANTAGE'],
                        link: '#competitiveLink',
                        icon: require('../assets/images/competative-link-icon.png')
                    },                        
                    {
                        title: ['核心價值', '核心价值' , 'CORE VALUE'],
                        link: '#coreLinks',
                        icon: require('../assets/images/core-link-icon.png')
                    },
                    {
                        title: ['招聘人才', '招聘人才' , 'PERSONNEL RECRUITMENT'],
                        link: '#personnelLink',
                        icon: require('../assets/images/personnel-link-icon.png')
                    },
                ],
                showList: false,
                showLanguange: false,
                activeLink: 0,
                selectedLanguange: 0,
                isAnimateChangeLanguageOn: false
            }
        },
        methods: {
            startPageAnimation(n) {
                this.$root.$emit('startPageAnimation', n)
            },
            show(isShow) {
                if(isShow) {
                    this.showList = true;
                } else {
                    this.showList = false;
                }
            },
            changeLanguage(n) {
                this.showList = false;
                let _this = this;
                this.selectedLanguange = n;
                this.startChangeLangAnimation()
                this.showLanguange = false;
                this.$root.$emit('languageChange', n)
                this.$root.$emit('animageChangeLanguage', n)
            },
            startChangeLangAnimation(){
                let _this = this;
                this.isAnimateChangeLanguageOn = true;
                _this.isAnimateChangeLanguageOn = false;
            },
            isChineseChar(n) {
                var b = false;
                if (n == 0 && n == 1) {
                    b = true;
                }
                return b
            },
            isSelected(n) {
                let b = false;
                if (n == this.selectedLanguange) {
                    b = true;
                }
                return b;
            },
            isActiveLink(n) {
                let b = false;
                if (n == this.activeLink) {
                    b = true;
                }
                return b;
            },
            changeActiveLink(n) {
                this.activeLink = n;
            },
            popModalShow(b){
                this.$root.$emit('popModalShow', b)
            }
        },
        mounted() {
            let _this = this;
            this.$root.$on('updateIntroSize', function(e) {
                _this.introHeight = e;
                
            })
            this.$root.$on('updateMngSize', function(e) {
                _this.magHeight = e;
 
            })
            this.$root.$on('updateCompSize', function(e) {
                _this.compHeight = e;

            })    
            this.$root.$on('updateCoreSize', function(e) {
                _this.coreHeight = e;

            })
            this.$root.$on('updatePerSize', function(e) {
                _this.perHeight = e;
   
            })
            this.$root.$on('closeLanguageSelection', function(e) {
                _this.showLanguange = e;
                _this.showList = e;
     
            })
            document.addEventListener('scroll', function(e) {
                let h = document.getElementById('chuangHeader').offsetHeight;
                let _scroll = e.target.scrollingElement.scrollTop;
                let first = _this.introHeight - h;
                let second = first + _this.magHeight - h + 85;
                let third = second + _this.compHeight - h + 85;
                let fourth = third + _this.coreHeight - h + 85;
                let fifth = fourth + _this.perHeight - h + 85;

                if(_scroll >= 0 && _scroll <= first){
                    _this.activeLink = 0;
                }else if(_scroll >= first && _scroll <= second){
                    _this.activeLink = 1;
                }else if (_scroll >= second && _scroll <= third) {
                    _this.activeLink = 2;
                }else if (_scroll >= third && _scroll <= fourth) {
                    _this.activeLink = 3;
                }else if (_scroll >= fourth && _scroll <= fifth) {
                    _this.activeLink = 4;
                }
            })
        },
    }
</script>
<style lang="less" scoped>

@import url('../assets/css/base.less');
    #chuangHeader {
        min-width: @min-width;
        z-index: 1000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        .col-left {
        }
        .col-right {
            height: 5.7rem;
            background-color: #000;
            p {
                color: #fff;
                width: 100%;
                cursor: pointer;
                text-indent: 1.3rem;
                font-size: @cons-description-text-size-1920 - 0.3;
            }
        }
    }
    .chuang-logo {
        cursor: pointer;
        width: 7.5rem;
        margin: 0.5rem;
        @media @990 {
            width: 5.7rem;
            margin: 0.5rem;
        }
        @media @768 {
            width: 6.5rem;
            margin: 0.5rem;
        }
        @media @479 {
            width: 5.6rem;
            margin: 0.5rem;
        }
        @media @320 {
            width: 5.6rem;
            
        }
    }
    .chuang-links {
        a {
            color: #e5e5e5;
            text-align: center;
            li {    
                height: 5.7rem;
                width: 9rem;
                line-height: 1.5rem;
                cursor: pointer;
                p {
                    width: inherit;    
                    font-size: @cons-description-text-size-1920 - 0.3;
                }
            }
        }
    }
    .chuang-links-for-c-char {
       a {
           
        li  {
                p {
                    font-size: 0.9rem!important;
                }
            }
       }
    }
    .hamburger,
    .close {
        width: 3rem;
        margin: 1rem;
        @media @768 {
            width: 2.8rem;
            padding-top: 0.4rem;
            margin: 1rem;
        }
        @media @479 {
            width: 2rem;
            padding-top: 0.5rem;
            margin: 0.8rem;
        }
    }
    .mobile-list {
        @mobile-list-width: 25;
        position: absolute;
        background-color: #fff;
        right: 0;
        top: 5.1rem;
        width:  @mobile-list-width;
        color: black;
        -webkit-box-shadow: 0px 3px 21.6px 2.4px rgba(0, 0, 0, 0.24);
        box-shadow: 0px 3px 21.6px 2.4px rgba(0, 0, 0, 0.24);
        @media @990 {
            width:  @mobile-list-width - 1;
            top: 4.9rem;
        }
        @media @768 {
            width:  @mobile-list-width - 1;
            top: 5.1rem;
        }
        @media @479 {
            width:  @mobile-list-width - 1;
            top: 4.4rem;
        }
        @media @320 {
            top: 4.4rem;
            width:  @mobile-list-width - 1;
        }
        .mobile-links-text {
            @mobile-link-text-size: 1.3rem;
            width: 92%;
            text-align: left;
            margin-left: 1rem;
            border-bottom: 1px solid #acacac;
            line-height: 4rem;
            color: #535353;
            font-size: 1.3rem;
            text-indent: 1rem;
            @media @990 {
                font-size: @mobile-link-text-size;
            }
            @media @768 {
                font-size: @mobile-link-text-size - 0.1;
            }
            @media @479 {
                font-size: @mobile-link-text-size - 0.1;
            }
            @media @320 {
                font-size: @mobile-link-text-size - 0.1;
            }
            img {
                margin-top: 0.8rem;
            }
            img:last-child {
                margin-left: 1rem; 
            }
            a {
                font-size: 1rem;
                p {
                    text-indent: 1rem;
                    color: #535353;
                    font-size: 1.5rem;
                }
                .mobile-text-english {
                        font-size: 1rem;
                }
                p:nth-child(1) {
                    width: 6.4rem;
                }
                p:nth-child(2) {
                    letter-spacing: -1px;
                }
            }
        }
    }
    .selectLanguage {
        right: 0;
        top: 5.7rem;
        padding: 2rem 1rem 2rem 1rem;
        background-color: #ffffff;
        position: absolute;
        width:16.5%;
        box-shadow: 0px 3px 21.6px 2.4px rgba(0, 0, 0, 0.24);
        ul {
            li {
                color: #535353;
                cursor: pointer;
                border-bottom: 1px solid #acacac;
                margin-bottom: 1rem;
                font-size: @cons-description-text-size-1920;
            }
        }
    }
    .solo-link {
        margin-top: 0;
        li {
            padding: 1rem;
            background-color: #000;
            cursor: pointer;
            margin-top: 0.3rem;
        }
    }
    .mobile-language-select {
        div {
            text-align: center;
            padding: 1rem;
            color: #e5e5e5;
            cursor: pointer;
            font-size: 1.3rem;
            background-color: #9F9F9F;
            border-right: 1px solid #e5e5e5;
        }
        div:last-child {
            border-right:none;
        }
        // div:nth-child(1) {
        //     background-color: #626262;
        // }
        // div:nth-child(2) {
        //     background-color: #7d7d7d;
        // }
        // div:nth-child(3) {
        //     background-color: #959595;
        // }
        .active {
            background-color: #626262!important;
            color: #e5e5e5!important;
        }
        .c-char-space {
            letter-spacing: 0.6rem;
        }

    }
    .list-text-size-for-c-char {
        font-size: 0.9rem!important;
    }
    .arrow-down {
        background: url('../assets/images/arrow-down.png') no-repeat center;
        width: 1rem;
        height: 1rem;
        margin-top: 0.4rem;
        margin-left: 0.6rem;
        position: absolute;

    }
    .arrow-down-eng {
        text-indent: 0.2rem!important;
        font-size: @cons-description-text-size-1920;
        span {
            margin-top: 0.4rem;
            margin-left: 0.6rem;
        }
    }
    .active-link {
        border-bottom: 2px solid #00a6fc;
    }
    .link {
        a:last-child {
            
          li:last-child {
              border-bottom: none;
          }  
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/ChuangHeader.vue